<template>
  <div>
    <m-row class="event-row">
      <m-col lg="3">
        <span class="name-title">{{$t('NATT.VANDRING')}}</span>
        <p>{{event.company.name}}</p>
      </m-col>
      <m-col lg="3">
        {{event.postaladdress}}
      </m-col>
      <m-col lg="3">
        {{event.from_datetime}}
      </m-col>
      <m-col lg="3">
        <memlist-circular-button
          class="fill-button-width"
          :text="$t('NATT.READ_MORE')"
          :primary_color="'white'"
          :secondary_color="'#8b0000e6'"
          :hover_color="'#e95050e6'"
          @click="read_more_event_clicked"
        />
      </m-col>
    </m-row>
  
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'NattEventRow',
  components: {
    
  },
  props: ['event'],
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentMember'])
  },
  mounted() {
    
  },
  data() {
    return {
      /*event: {
        company: {
          name: 'Husby boysen'
        },
        event_id: 1,
        from_datetime: '2025-05-12 20:00',
        name: 'Vandring i husby',
        postaladdress: 'Husby centrum',
        google_maps: {
          lat: 59.349214,
          lng: 18.035804
        }
      },*/
      
    };
  },
  watch: {

  },
  methods: {
    
    read_more_event_clicked() {
      location.href = '/event/' + this.event.event_id;
    }
  }
};
</script>
<style scoped>

h3 {
  font-size: 22px;
  font-weight: bold;
}

p {
  margin-bottom: 0px !important;
}
.name-title {
  color: #8b0000e6;
}
.events-section {
  font-size: 16px;
}
.event-row {
  display: flex; 
  flex-wrap: wrap;
  align-items: flex-end;
}
</style>